<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" maxlength="80" v-uppercase />
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        
        <div v-if="lsDados.length>0">
            <div class="table-wrapper"><table>
                <thead><tr>
                    <th>Código</th>
                    <th>Nome/Identificação</th>
                    <th>Grupo/Equipamento</th>
                    <th>Situação</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdplano) }}</td>
                    <td>{{ obj.nmplano }}</td>
                    <td class="col-width-char40">{{ obj.nmgrupo }}{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.nmativo }}</td>
                </tr></tbody>
            </table></div>


            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>


    <div v-if="modoEdicao">
        <ManutPlanoEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @salvo="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ManutPlanoEditPage from '../formularios/ManutPlanoEditPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';


const emit = defineEmits(['close']);


const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(false);
const nmPesquisa = ref(null);


const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


function editarCadastro(obj) {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/manut_plano', {idmunicipio: globalStore.idmunicipio, nmpesquisar: nmPesquisa.value });
        lsDadosMain.value = req;
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function novoCadastro() {
    idEdicao.value = 0;
    modoEdicao.value = true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados)
</script>
